import { IconType } from "react-icons"

const InfoComponent = ({InfoIcon,text,color}: {text:string, InfoIcon:IconType,color:string}) => {
    return (
        <div style={{display: "flex", flexDirection: "row", alignItems: "center", alignSelf:"flex-start", marginLeft: 5, marginTop:10}}>
            <InfoIcon size={30} color={color} />
            <p style={{color:color}}>{text}</p>
        </div>
    )
}

export default InfoComponent